import { gsap } from 'gsap';

export function tutorialEnter(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .fromTo(el, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      ease: 'power3.easeInOut',
      duration: 1.2,
      clearProps: 'all',
    }, 'start');

  return tl;
}

export function tutorialLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, duration: 0.5, ease: 'power3.easeOut' }, 'start');

  return tl;
}
